module.exports = __webpack_public_path__ + "c6ffb9c840a33b8a44d2b1e8ed810f88.pdf";